import { CalculationIndexRouteView } from './view';

export const indexRoute = {
  index: true,
  element: <CalculationIndexRouteView/>,
};